import React from 'react';

function MapMarker() {
  /* eslint-disable max-len */
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.348 0C7.733 0 4 3.68 4 8.229 4 14.4 12.348 23.51 12.348 23.51s8.348-9.11 8.348-15.281c0-4.55-3.733-8.229-8.348-8.229zm0 11.167c-1.646 0-2.982-1.316-2.982-2.938 0-1.623 1.336-2.94 2.982-2.94 1.646 0 2.981 1.317 2.981 2.94 0 1.622-1.335 2.938-2.981 2.938z" />
    </svg>
  );
  /* eslint-enable */
}

export default MapMarker;



// WEBPACK FOOTER //
// ./src/common/icons/MapMarker.js